export const DENTIST_FIELDS = {
  id: 'id',
  fullName: 'fullName',
  email: 'email',
  specialty: 'specialty',
  profileImage: 'profileImage',
  profileImageUrl: 'profileImageUrl',
  profileStatus: 'profileStatus',
};
